import { Box } from '@mantine/core';
import { keyframes } from '../utils/keyframes';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface FlashProps {
  children: React.ReactNode;
  active?: boolean;
  duration?: number;
  infinite?: boolean;
  count?: number;
}

const flashKeyframes = keyframes({
  '0%, 50%, 100%': { opacity: 1 },
  '25%, 75%': { opacity: 0 },
});

const Flash = forwardRef<HTMLDivElement, FlashProps>(
  (
    {
      children,
      active = true,
      duration = 1000,
      infinite = false,
      count = 1,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();

    if (reducedMotion || !active) {
      return <Box ref={ref}>{children}</Box>;
    }

    const iterationCount = infinite ? 'infinite' : count;

    return (
      <Box
        ref={ref}
        style={{
          animation: `${flashKeyframes} ${duration}ms ease-in-out ${iterationCount}`,
        }}
      >
        {children}
      </Box>
    );
  }
);

Flash.displayName = 'Flash';

export default Flash;
